import React, { useContext } from 'react';
import { SiteContext } from '../../contexts/SiteContext';

export default function PrivacyPolicy({t}) {
  const { website } = useContext(SiteContext);

  const SITE   = website?.title || t('legal.privacy.fallbackSite', { defaultValue: 'Your Website' });
  const EMAIL  = 'info@vbwebb.se';
  const UPDATED = '2025-10-08';

  return (
    <div className="max-w-4xl mx-auto bg-white border rounded shadow p-6 md:p-8">
      <h1 className="text-3xl font-bold mb-2">{t('legal.privacy.title')}</h1>
      <p className="text-sm text-gray-500 mb-8">
        {t('legal.privacy.lastUpdated', { date: UPDATED })}
      </p>

      <p className="mb-6">
        {t('legal.privacy.intro', { site: SITE })}
      </p>

      <section className="space-y-5">
        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.privacy.collect.title')}</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>{t('legal.privacy.collect.items.account')}</li>
            <li>{t('legal.privacy.collect.items.content')}</li>
            <li>{t('legal.privacy.collect.items.usage')}</li>
            <li>{t('legal.privacy.collect.items.cookies')}</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.privacy.use.title')}</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>{t('legal.privacy.use.items.provide')}</li>
            <li>{t('legal.privacy.use.items.communicate')}</li>
            <li>{t('legal.privacy.use.items.security')}</li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.privacy.sharing.title')}</h2>
          <p>{t('legal.privacy.sharing.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.privacy.transfers.title')}</h2>
          <p>{t('legal.privacy.transfers.body')}</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">{t('legal.privacy.contact.title')}</h2>
          <p>
            {t('legal.privacy.contact.body')}{' '}
            <a className="text-blue-700 underline" href={`mailto:${EMAIL}`}>{EMAIL}</a>.
          </p>
        </div>
      </section>
    </div>
  );
}
